module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjE0IiBjeT0iMTQiIHI9IjEzLjUiIHN0cm9rZT0id2hpdGUiLz4NCjxsaW5lIHgxPSIyMS4yOTM0IiB5MT0iNy4yMDk1OSIgeDI9IjcuMjA5NTkiIHkyPSIyMS4yOTM0IiBzdHJva2U9IndoaXRlIi8+DQo8bGluZSB4MT0iNy4yMDk1NyIgeTE9IjYuNzA2NiIgeDI9IjIxLjI5MzQiIHkyPSIyMC43OTA0IiBzdHJva2U9IndoaXRlIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/cancel_black.svg
// module id = uzDf
// module chunks = 1